import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicesService } from '../../../core/services/services.service';

@Component({
  selector: 'app-single-view-service',
  templateUrl: './single-view-service.component.html',
  styleUrls: ['./single-view-service.component.scss'],
})
export class SingleViewServiceComponent implements OnInit {
  breadcrumbs: any[] = [];
  fleetId: any;
  actionListForm: FormGroup | any;
  serviceId: any;
  serviceData: any;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private servicesService: ServicesService,
  ) {}

  ngOnInit() {
    this.loading = true;
    this.serviceId = this.route.snapshot.paramMap.get('id');
    this.fleetId = this.route.snapshot.paramMap.get('fleetId');
    this.initActionList();
    this.servicesService.getOneServiceInfoById(this.serviceId).then((res) => {
      this.serviceData = res;
      this.addBreadcrumbsInfo();
      this.actionListForm.patchValue(this.serviceData.actionList);
      this.loading = false;
    });
  }

  addBreadcrumbsInfo() {
    this.breadcrumbs = [
      {
        title: 'Fleet',
        icon: 'car',
        route: '/admin/fleets',
      },
      {
        title: this.serviceData?.fleet?.vehicleDetails?.registrationNumber,
        route: `/admin/fleets/${this.fleetId}`,
      },
      {
        title: 'Service Records',
        route: [`/admin/fleets/${this.fleetId}`, { pageName: 'fleetService' }],
      },
      {
        title: this.serviceData?.refNo,
      },
    ];
  }

  initActionList() {
    this.actionListForm = this.fb.group({
      isOilChange: [],
      isOilFilterChange: [],
      isTransIolCheck: [],
      isCoolantCheck: [],
      isBreakOilCheck: [],
      isNextBreakOilCheck: [],
      isAirFilterCheck: [],
      isNextAirFilterCheck: [],
      isBatteryCheck: [],
      isNextBatteryCheck: [],
      isCabinFilterCheck: [],

      isBreakPadCheck: [],
      isNextBreakPadCheck: [],
      isTypeCheck: [],
      isNextTypeCheck: [],

      isUnderCarriageCheck: [],
      isBootCheck: [],
      isOilLeakCheck: [],

      isWiperCheck: [],
      isNextWiperCheck: [],
      isHornCheck: [],
      isInteriorCheck: [],
      isACCheck: [],
      isBluetoothCheck: [],
      isInteriorLightCheck: [],
      isPowerMirrorCheck: [],
      isPowerShutterCheck: [],
      isHandBreakCheck: [],
      isSpareWheelCheck: [],
      isToolkitCheck: [],
      isGlueBottleCheck: [],

      isFrontHeadLightCheck: [],
      isFrontSignalLightCheck: [],
      isFogLightCheck: [],
      isWinkerLightCheck: [],
      isRearSignalLightCheck: [],
      isBreakLightCheck: [],
      isReversLightCheck: [],

      isCarpetWashCheck: [],
      isFullBodyWashCheck: [],
      isUnderCarriageWashCheck: [],
      isEngineGreasingCheck: [],
    });
  }

  serviceTypeLabelPreview(name: string) {
    let value = '-';
    switch (name) {
      case 'NORMALSERVICE': {
        value = 'Normal service';
        break;
      }
      case 'TRANSMISSION': {
        value = 'Transmission oil change';
        break;
      }
      default: {
        break;
      }
    }
    return value;
  }

  labelValOnServiceType(name: string) {
    let value = '-';
    switch (name) {
      case 'SR': {
        value = 'SR';
        break;
      }
      case 'OWNER': {
        value = 'Vehicle Owner';
        break;
      }
      default: {
        break;
      }
    }
    return value;
  }
}
